import { render, staticRenderFns } from "./SidebarNavLink.vue?vue&type=template&id=3026a02a"
import script from "./SidebarNavLink.vue?vue&type=script&lang=js"
export * from "./SidebarNavLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports